export const SEARCH_HIGHLIGHT_COLOR = "rgba(255, 235, 59, 0.34)";
export const ACTIVE_SEARCH_HIGHLIGHT_COLOR = "rgba(251, 191, 36, 0.42)";

export const SEARCH_HIGHLIGHT_STYLE_ID = "embedpdf-search-highlight-style";

export const SEARCH_HIGHLIGHT_STYLE_TEXT = `
div[style*="mix-blend-mode: multiply"][style*="transform: scale(1.02)"][style*="transition: opacity .3s ease-in-out"] {
  opacity: 0.42 !important;
}
`;
